export enum ZoomLevel {
  COMPACT,
  STANDARD,
  DETAILED
}
